var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import moment from "moment";
import { injectIntl } from "@irati/utils/lang";
import { DatePicker, RadioFilter } from "@irati/ui/src/FormItem";
import { Wrapper, Title, StyledRow } from "./styled";
export var Times;
(function (Times) {
    Times["allTime"] = "allTime";
    Times["last1Month"] = "last1Month";
    Times["last3Months"] = "last3Months";
    Times["setTimeFrame"] = "setTimeFrame";
})(Times || (Times = {}));
var DateFilter = /** @class */ (function (_super) {
    __extends(DateFilter, _super);
    function DateFilter(props) {
        var _this = _super.call(this, props) || this;
        _this.buildFromTime = function (dateValue) {
            if (dateValue === Times.last1Month) {
                return moment().subtract(1, "month");
            }
            else if (dateValue === Times.last3Months) {
                return moment().subtract(3, "month");
            }
            return null;
        };
        _this.handleFilterChange = function (currentDateValue) {
            var from = _this.buildFromTime(currentDateValue);
            var to = null;
            _this.setState({
                currentDateValue: currentDateValue,
                to: to,
                from: from
            });
        };
        _this.handleFromChange = function (from) {
            _this.setState({ from: from });
        };
        _this.handleToChange = function (to) {
            _this.setState({ to: to });
        };
        _this.handleReset = function () {
            _this.setState({
                currentDateValue: Times.allTime,
                from: null,
                to: null,
                prevDateValue: Times.allTime,
                prevFrom: null,
                prevTo: null
            });
            _this.props.onChange({ from: null, to: null });
        };
        _this.handleToggle = function () {
            var _a = _this.state, prevFrom = _a.prevFrom, prevTo = _a.prevTo, prevDateValue = _a.prevDateValue;
            _this.setState({
                from: prevFrom,
                to: prevTo,
                currentDateValue: prevDateValue
            });
        };
        _this.handleFilterClick = function () {
            var _a = _this.state, from = _a.from, to = _a.to, currentDateValue = _a.currentDateValue;
            _this.setState({
                prevFrom: from,
                prevTo: to,
                prevDateValue: currentDateValue
            });
            _this.props.onChange({ from: from && moment.utc(from.startOf("day")).format(), to: to && moment.utc(to.endOf("day")).format() });
        };
        _this.shouldFillIcon = function () {
            return _this.state.prevDateValue !== Times.allTime;
        };
        _this.state = {
            currentDateValue: Times.allTime,
            from: null,
            to: null,
            prevDateValue: Times.allTime,
            prevFrom: null,
            prevTo: null
        };
        return _this;
    }
    DateFilter.prototype.render = function () {
        var idNamespace = "RewardDateHeader";
        var _a = this.state, currentDateValue = _a.currentDateValue, from = _a.from, to = _a.to;
        var formatMessage = this.props.formatMessage;
        var options = [
            { value: Times.allTime, label: formatMessage({ id: "platform.fields.dateFilter.allTime" }) },
            { value: Times.last1Month, label: formatMessage({ id: "platform.fields.dateFilter.last1Month" }) },
            { value: Times.last3Months, label: formatMessage({ id: "platform.fields.dateFilter.last3Months" }) },
            { value: Times.setTimeFrame, label: formatMessage({ id: "platform.fields.dateFilter.setTimeFrame" }) }
        ];
        return (React.createElement(Wrapper, { id: idNamespace, leftAlign: true },
            React.createElement(Title, null, formatMessage({ id: name || "platform.fields.dateFilter.title" })),
            React.createElement(RadioFilter, { options: options, value: currentDateValue, onReset: this.handleReset, onFilter: this.handleFilterClick, onChange: this.handleFilterChange, footer: true, overflow: true, shouldFillIcon: this.shouldFillIcon, onToggle: this.handleToggle, toggleModalOnChange: false }, currentDateValue === Times.setTimeFrame && (React.createElement(React.Fragment, null,
                React.createElement(StyledRow, null,
                    React.createElement(DatePicker, { label: formatMessage({ id: "platform.fields.dateFilter.datePicker.from.label" }), name: "filterByDateFrom", value: from, minDate: moment()
                            .subtract(1, "year")
                            .toDate(), maxDate: to ? to.toDate() : moment().toDate(), onChange: this.handleFromChange }),
                    React.createElement(DatePicker, { label: formatMessage({ id: "platform.fields.dateFilter.datePicker.to.label" }), name: "filterByDateTo", value: to, minDate: from
                            ? from.toDate()
                            : moment()
                                .subtract(1, "year")
                                .toDate(), maxDate: moment().toDate(), onChange: this.handleToChange })))))));
    };
    DateFilter.defaultProps = {
        onChange: function () { },
        leftAlign: false
    };
    return DateFilter;
}(Component));
export default injectIntl(DateFilter);
